import React from "react";
import {useNotify} from "react-admin";
import {ENABLE_PLAID_LINKING} from "../../../config";

export const VerifyThroughPlaid = () => {
  const notify = useNotify();
  const handleClick = async (e) => {
    e.preventDefault();
    notify("Something went wrong while trying to connect to your bank. Please try again later.", {
      type: "error",
      anchorOrigin: {vertical: "top", horizontal: "right"},
    });
  };
  return ENABLE_PLAID_LINKING ? (<>
      <div className="expand-heads d-flex">
        <button
          className=" ml-auto"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#anotherway-det-coll3"
          aria-expanded="false"
          aria-controls="anotherway-det-coll3"
          style={{fontSize: "15px"}}
        >
          Provide proof another way
          <span>
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.99999 3.78047L8.29999 0.480469L9.24266 1.42314L4.99999 5.6658L0.757324 1.42314L1.69999 0.480469L4.99999 3.78047Z"
                  fill="#2DC3E8"
                />
              </svg>
            </span>
        </button>
      </div>
      <div className="collapse" id="anotherway-det-coll3">
        <div className="d-flex"
             style={{alignItems: 'center', justifyContent: 'flex-end', gap: '0.75rem'}}>
          {/* Icon */}
          <svg
            width="32"
            height="32"
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="#111" fillRule="evenodd">
              <path
                d="M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063L18.637 0zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856L9.71 6.624zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187-4.808-4.936zM4.672 17.238l2.111-7.705 6.125 6.288-4.886 4.856-3.35-3.44zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384-4.809-4.935zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856-4.808-4.936zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856-4.808-4.936zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856-4.807-4.936zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186-1.988-7.738zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856-4.809-4.936zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705-6.128-6.288zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385-7.63-2.133zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007-3.35-3.44z"/>
            </g>
          </svg>

          {/* Text */}
          <div>
            <a href="#"
               onClick={handleClick}
            >
              Verify Income through bank deposits
            </a>
            <div style={{fontSize: '0.8125rem', color: '#444', lineHeight: '1.3'}}>
              (This requires you to provide a third party, Plaid, with your bank login credentials.)
            </div>
          </div>
        </div>
      </div>
    </>
  ) : <></>
}
